<template>
  <form
    class="login-form wmin-sm-400"
    action="index.html"
  >
    <div class="card mb-0">
      <ul class="nav nav-tabs nav-justified alpha-grey mb-0">
        <li class="nav-item text-center">
          <router-link
            :to="{ name: 'auth.login' }"
            class="nav-link border-y-0 border-left-0 active"
          >
            <h6 class="my-1">
              <i class="fas fa-house-user mr-2" />{{ $t('Sign in') }}
            </h6>
          </router-link>
        </li>
        <li class="nav-item text-center">
          <router-link
            :to="{ name: 'auth.register' }"
            class="nav-link border-y-0 border-right-0"
          >
            <h6 class="my-1">
              <i class="fas fa-book-user mr-2" />{{ $t('Register') }}
            </h6>
          </router-link>
        </li>
      </ul>

      <div class="tab-content card-body">
        <div class="tab-pane fade show active">
          <login-component :redirect="(this.$route.query.redirect) ? this.$route.query.redirect : ''" />
        </div>
        <!-- <div class="tab-pane fade">
                <register-component></register-component>
            </div> -->
      </div>
    </div>
  </form>
</template>

<script>
import LoginComponent from "./Login";
// import RegisterComponent from "./Register";
import VerifyComponent from "./Verify";
import Cookies from 'js-cookie'

export default {
    components: {
        LoginComponent,
        // RegisterComponent,
        // VerifyComponent,
    },
    created() {
         window.addEventListener('beforeunload', () => Cookies.remove('loginBrowser'));
    },
};
</script>



// WEBPACK FOOTER //
// src/components/central/authorization/IndexLogin.vue